import { render, staticRenderFns } from "./authForgotPassSuccess.vue?vue&type=template&id=229a147e&scoped=true"
import script from "./authForgotPassSuccess.vue?vue&type=script&lang=js"
export * from "./authForgotPassSuccess.vue?vue&type=script&lang=js"
import style0 from "./authForgotPassSuccess.vue?vue&type=style&index=0&id=229a147e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229a147e",
  null
  
)

export default component.exports